module.exports = __webpack_public_path__ + "img/3-days-left.dc4d7426.svg";